import React, { useState } from "react";
import { createUserWithEmailAndPassword, GoogleAuthProvider, sendEmailVerification, signInWithPopup } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, firestore } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function SignUp() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // Fungsi signup email/password
  const handleSignUp = async () => {
    if (!username || !email || !password) {
      alert("Semua field wajib diisi!");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await sendEmailVerification(user);
      
      // Set role default "user" di Firestore
      await setDoc(doc(firestore, 'Users', user.uid), {
        email: user.email,
        username: username,
        role: 'user',
        createdAt: new Date(),
      });
      alert('Akun dibuat! Cek email untuk verifikasi, lalu login.');
      navigate('/login');  // Redirect ke login
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      {/* Background blur (opsional) */}
      <div className="absolute inset-0 bg-[radial-gradient(at_50%_30%,rgba(16,185,129,0.15),transparent)]"/>

      <div className="relative w-full max-w-[350px] bg-white rounded-4xl border-4 border-white shadow-custom p-6 md:p-9">
        <button
          onClick={() => navigate('/cover')}
          className="flex items-center text-lg text-primaryDark disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={20} />
        </button>
        <h1 className="text-center text-3xl font-black text-primary mb-2">Register</h1>

        {/* Don't have an account? */}
        <div className="text-center mt-4">
          <p className="text-sm text-gray-700">
            Already have an account?{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/login');
              }}
              className="text-primaryDark font-semibold no-underline transition-colors duration-300 hover:text-primary"
            >
              Log In
            </a>
          </p>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); }} className="mt-5 space-y-4">
          <input
            required
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            className="w-full bg-white border-none rounded-full px-5 py-4 shadow-input focus:outline-none focus:ring-2 focus:ring-primaryDark"
          />
          <input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-white border-none rounded-full px-5 py-4 shadow-input focus:outline-none focus:ring-2 focus:ring-primaryDark"
          />
          <input
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-white border-none rounded-full px-5 py-4 shadow-input focus:outline-none focus:ring-2 focus:ring-primaryDark"
          />
          <button
            onClick={handleSignUp}
            className="w-full font-bold bg-gradient-to-r from-emerald-600 to-cyan-500 text-white py-4 rounded-full shadow-btn hover:scale-[1.03] active:scale-[0.95] transition-transform duration-200"
          >
            Daftar
          </button>
        </form>
      </div>
    </div>
  );
}